import ICustomForm from "../../ICustomForm";
import Battery from "../Battery";
import m, {Vnode} from "mithril";
import {inputTextItemView} from "../../../ui/items/inputText";

export default class BatteryDefault extends Battery implements ICustomForm {

    viewOptions(): Vnode {
        const form = this.settings.form;
        const questionary = form.questionary;
        const options = [];
        for (const answer of this.questionCard.answers) {
            if (!answer.radio.cell.isVisible() || !answer.radio.cell.enabled) {
                continue;
            }
            const inputText = answer.radio.cell.getInputText();
            const checked = answer.radio.isChecked();
            const cssClass = (answer.radio.cell.cssClass ? (' '+answer.radio.cell.cssClass) : '')
                + (checked ? ' checked' : '') // this radio is checked
                + (!checked && answer.radio.getVariable() ? ' unchecked' : '') // sibling radio is checked
            ;

            options.push(
                m('label', {
                    "class": cssClass,
                    onclick: () => this.onAnswerSelect(answer),
                }, [
                    m('input', {
                        type: 'radio',
                        value: answer.radio.getValue(),
                        name: 'batteryAnswer',
                        checked: answer.radio.isChecked()
                    }),
                    m('span', {}, [
                        m.trust(questionary.renderText(answer.label)),
                        (checked && inputText) ? m('.', {}, [
                             inputTextItemView(inputText),
                        ]) : null
                    ]),
                ])
            );
        }

        const isAnswered = this.questionCard.isAnswered() ? "answered" : "not-answered";
        return m('.options.'+isAnswered, {}, options);
    }


}
